class RegisterDataCtrl {
  constructor($scope) {
    this.$scope = $scope;

    this.name = null;
    this.surname = null;
    this.email = null;
    this.password = null;
    this.pesel = null;
    this.citizenship = null;
    this.citizenshipError = null;
    this.appendHistoricalRecruitment = true;
    this.consentsExpandStatuses = {};
    this.passInputType = 'password';
  }

  $onInit() {
    this.citizenship = window.citizenship;
    this.appendHistoricalRecruitment = window.locale === 'pl';
  }

  changeConsentExpandStatus(consent) {
    if(undefined === this.consentsExpandStatuses[consent]) {
      this.consentsExpandStatuses[consent] = {consent: true, preamble: false};

      return;
    }

    this.consentsExpandStatuses[consent].consent = !this.consentsExpandStatuses[consent].consent;
  }

  toggleShowPassword($event) {
    $event.preventDefault();
    if (this.passInputType === 'password') {
      this.passInputType = 'text';
    } else {
      this.passInputType = 'password';
    }

    $('#user_register_form_password').attr('type', this.passInputType);
  }

  changePreambleExpandStatus(consent) {
    if(undefined === this.consentsExpandStatuses[consent]) {
      this.consentsExpandStatuses[consent] = {preamble: true, consent: false};

      return;
    }

    this.consentsExpandStatuses[consent].preamble = !this.consentsExpandStatuses[consent].preamble;
  }

  consentExpandStatus(consent) {
    if(undefined === this.consentsExpandStatuses[consent]) {
      return false;
    }

    return this.consentsExpandStatuses[consent].consent;
  }

  consentPreambleExpandStatus(consent) {
    if(undefined === this.consentsExpandStatuses[consent]) {
      return false;
    }

    return this.consentsExpandStatuses[consent].preamble;
  }

  submit(e) {
    if (this.appendHistoricalRecruitment && this.citizenship === '') {
      this.citizenshipError = Translator.trans('this_field_is_required', { }, 'validators');
      e.preventDefault();
    }
  }
}

RegisterDataCtrl.$inject = ['$scope'];

export default RegisterDataCtrl;
